// extracted by mini-css-extract-plugin
export default {"Container":"Footer_Container__oVFK4","color":"Footer_color__UAN4g"};